import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IOrganizationLockDto } from '@/dtos';

export const GET_ORGANIZATION_LOCKS_KEY = 'GET_ORGANIZATION_LOCKS';

const formatOrgLocks = (data: IOrganizationLockDto) => ({
  isLocked: data?.is_locked,
  organizationId: data?.organization_id,
  updatedDate: data?.updated_at as unknown as string,
  hasReplenishedAccounts: data?.has_replenished_accounts,
});

const useGetOrgLocksQuery = (id?: string) => {
  const { isLoading, isError, data } = useQuery(
    [GET_ORGANIZATION_LOCKS_KEY, id],
    () => api.get(API_URL.ORGANIZATION_LOCKS_BY_ORGANIZATION_ID(id || '')),
    {
      enabled: !!id,
    }
  );

  return {
    formattedData: data?.data ? formatOrgLocks(data?.data) : undefined,
    isLoading,
    isError,
  };
};

export default useGetOrgLocksQuery;
